import { Component } from 'react';
import PropTypes from 'prop-types';
import User from 'services/user2';

import { withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

const styles = {
  root: {
    width: '100%',
  },
  input: {
    color: '#222',
  },
  icon: {
    color: '#222',
  },
};

class Company extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyName: '',
      idx: 0, //当前公司下标
      isShowSearch: false,
    };
    this.companyOptions = [
      {
        items: [],
      },
    ];
    this.emitChange = this.emitChange.bind(this);
    this.companyList = [];
    this.lang = { leftBtn: '取消', rightBtn: '确定' };
    this.searchKey = '';
  }

  init() {
    let companyList = (this.companyList = User.getCompanyList());
    let companyInfo = User.getCompanyInfo();
    if (companyInfo === undefined) {
      return;
    }
    let companyCode = companyInfo.companyCode;
    let idx = this.state.idx;
    this.companyOptions[0].items = [];
    companyList.forEach((item, i) => {
      if (companyCode === item.companyCode) {
        idx = i;
      }
      this.companyOptions[0].items.push({
        label: item.companyName,
      });
    });
    this.setState(
      { companyName: User.getCompanyInfo().companyName, idx },
      () => { }
    );
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() { }

  emitChange(companyCode) {
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(companyCode);
    }
  }

  cancelSearch() { }

  submitSearch() { }

  handleSelectChange = event => {
    let idx = event.target.value;
    if (idx === this.state.idx) {
      return;
    }
    let companyCode = this.companyList[idx].companyCode;
    User.setCompanyCode(companyCode);
    this.setState({ companyName: User.getCompanyInfo().companyName, idx });
    this.emitChange(companyCode);
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Select
          value={this.state.idx}
          onChange={this.handleSelectChange}
          inputProps={{
            name: 'company',
            id: 'company-simple',
          }}
          classes={{ select: classes.input, icon: classes.icon }}
          className="select-company-list"
        >
          {this.companyOptions[0].items.map((item, index) => (
            <MenuItem key={index} value={index}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
      </div>
    );
  }
}

Company.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Company);
